const EN_CUSTOM = {

}

export default EN_CUSTOM;